const WHITE_LIST_DD_ENV = ['dev', 'uat', 'prod'];

export { WHITE_LIST_DD_ENV };
